import React from "react";
import WorldMap from "./worldMap";
import { useTranslation } from "react-i18next";

const OurFootprintSection = () => {
  const { t } = useTranslation();

  return (
    <section className="swiss-section">
      <div className="swiss-grid">
        <div className="col-span-12 lg:col-span-2 mb-6 lg:mb-0">
          <span className="swiss-num">05 / {t("Footprint")}</span>
        </div>

        <div className="col-span-12 lg:col-span-10">
          <h2 className="text-h2 font-bold tracking-tight text-ink max-w-[20ch] mb-6">
            {t("From Local to Global")}
          </h2>
          <p className="text-body-lg text-ink-70 max-w-prose">
            {t(
              "Tenerife, our chosen oasis in the Island of Eternal Spring. Cradled between volcano and ocean, caressed by the Alisi winds — a canvas where ideas are nurtured and brought to life."
            )}
          </p>
        </div>
      </div>

      <div className="swiss-grid mt-9">
        <div className="col-span-12">
          <WorldMap />
        </div>
      </div>

      <div className="swiss-grid mt-9">
        <div className="col-span-12 lg:col-span-2">
          <span className="swiss-caption">{t("Sustainable Innovation")}</span>
        </div>
        <div className="col-span-12 lg:col-span-10 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
          <div className="border-t border-ink pt-4">
            <h3 className="text-h4 font-medium tracking-tight text-ink mb-3">
              {t("Global Footprint")}
            </h3>
            <p className="text-body text-ink-70 max-w-measure">
              {t(
                "Beyond Tenerife: projects spanning the Mexican Riviera Maya, Italy, France, Amsterdam, Thailand, Egypt, Zanzibar, Cyprus, Jamaica, Saint Kitts and Nevis, Balmoral Island, and the UK."
              )}
            </p>
          </div>
          <div className="border-t border-ink pt-4">
            <h3 className="text-h4 font-medium tracking-tight text-ink mb-3">
              {t("Always Responsible")}
            </h3>
            <p className="text-body text-ink-70 max-w-measure">
              {t(
                "In each location, we build solutions that meet present needs while contributing to a sustainable and responsible future."
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurFootprintSection;
